import CustomRoute from './CustomRoute';

export default CustomRoute;
